import { Injectable } from '@angular/core';

/**
 * The zero-block widgets created in this session that have not been measured yet.
 *
 * A new widget is seeded with a size its content need not match — a button's label comes from the user's
 * translation — so its view measures it on the first render. A widget that arrived with the page is not
 * measured until it changes, or opening the page would re-save it.
 */
@Injectable({ providedIn: 'root' })
export class NewZeroWidgetsService {
    private readonly ids = new Set<string>();

    public mark(id: string): void {
        this.ids.add(id);
    }

    /** True once per created widget — the first view that renders it takes the mark. */
    public consume(id: string): boolean {
        return this.ids.delete(id);
    }
}
